import { IPhotoRevealEntry } from '../../../photoReveals/types';
import { IApiPhotoReveal } from './photoReveals.types';

export const photoRevealSerializer = ({
  relationships: { score, senderMainPicture, ...relations },
  ...rest
}: IApiPhotoReveal): IPhotoRevealEntry => ({
  relationships: {
    ...relations,
  },
  ...rest,
});
